module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section06_01_american-village-b95e4dfd2dfe96a755c9d82776c9e0ee.jpg";